import React from "react";
import { TONE } from "./refUtils";

export const Badge = ({ children, tone = "slate", tid, title }) => (
  <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10.5px] font-medium whitespace-nowrap ${TONE[tone] || TONE.slate}`} data-testid={tid} title={title}>{children}</span>
);

export const Kpi = ({ label, value, sub, tid, tone = "text-slate-900" }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-3.5" data-testid={tid}>
    <p className="text-[11px] text-slate-400">{label}</p>
    <p className={`text-xl font-bold mt-0.5 ${tone}`}>{value}</p>
    {sub && <p className="text-[10.5px] text-slate-400 mt-0.5">{sub}</p>}
  </div>
);

export const Section = ({ title, right, children, tid, className = "" }) => (
  <section className={`bg-white rounded-xl border border-slate-200 p-4 ${className}`} data-testid={tid}>
    <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
      <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
      {right}
    </div>
    {children}
  </section>
);

export const Field = ({ label, children, hint, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="text-[11px] text-slate-500">{label}</span>
    <div className="mt-0.5">{children}</div>
    {hint && <p className="text-[10px] text-slate-400 mt-0.5">{hint}</p>}
  </label>
);

export const Empty = ({ children, tid }) => <p className="text-xs text-slate-400 text-center py-6" data-testid={tid}>{children}</p>;
